import React from "react";
import DashboardV2 from "../dashboard/DashboardV2";
import DashboardHubV3 from "./DashboardHubV3";
import { useSensorList } from "./dashV3.data";

const HUB_THRESHOLD = 6;

export default function DashboardEntryV3() {
  const { loading, water, pumps, borewells, valves } = useSensorList();

  if (loading) return null; // overlay in Pages.js still covers this phase

  const cardCount = water.length + pumps.length + borewells.length + valves.length;
  return cardCount > HUB_THRESHOLD ? <DashboardHubV3 /> : <DashboardV2 />;
}